import { OFFICE_365_PERMISSION_MODULE_NAME, OFFICE_365_PERMISSION_PATH } from '@my-backoffice/app/pages/login/federated/office365/constants/office365-auth.constants';
import { MOCK_OFFICE365_USER_PERMISSIONS } from '@my-backoffice/app/pages/login/federated/office365/constants/office365-permissions-mock.constants';
import { IHttpResponseBody } from '@my-backoffice/app/shared/models/interfaces/http-response-body.interface';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, of } from 'rxjs';

const CURRENT_USER_SUFFIX = `/users/current-user`;

@Injectable()
export class Office365PermissionsMockInterceptor implements HttpInterceptor {
  /**
   * @template T
   * @param {Readonly<HttpRequest<T>>} request - Outgoing HTTP request.
   * @param {Readonly<HttpHandler>} next - Next handler in the interceptor chain.
   * @returns {Observable<HttpEvent<T>>} Mock permissions or forwarded request.
   */
  public intercept<T>(request: Readonly<HttpRequest<T>>, next: Readonly<HttpHandler>): Observable<HttpEvent<T>> {
    if (!isDevMode() || !this._isCurrentUserPermissionsRequest(request.url)) {
      return next.handle(request);
    }

    const body: IHttpResponseBody<string[]> = {
      message: 'request successful',
      content: MOCK_OFFICE365_USER_PERMISSIONS,
    };

    return of(
      new HttpResponse({
        status: 200,
        body: body as T,
      })
    );
  }

  private _isCurrentUserPermissionsRequest(url: string): boolean {
    return url.includes(OFFICE_365_PERMISSION_PATH) && url.includes(OFFICE_365_PERMISSION_MODULE_NAME) && url.includes(CURRENT_USER_SUFFIX);
  }
}
